var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-3 of gap-2"},_vm._l((_vm.getKeys),function(key){return _c('touch-optimized-button',{key:key.key,class:[key.extraClasses !== undefined ?  key.extraClasses : ''],attrs:{"padding":"py-4","size":"text-3xl","type":"dark"},on:{"click":function($event){return key.action()}}},[_vm._v(" "+_vm._s(key.key)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }